import React from "react";
import { DialogActions } from "components/MaterialDialog";
import { Button, SecondaryButton } from "components/Form";
import { useFormikContext } from "formik";
import { getFilterConf } from "components/Filter/filterIds";
import { pluralize } from "lib/pluralize";

interface ModalActionsProps {
  onClose: () => void;
  filterIds: string[];
  readOnly?: boolean;
}
export function ModalActions(props: ModalActionsProps): React.JSX.Element {
  const { filterIds = [], onClose, readOnly = false } = props;

  const { isValid, values } = useFormikContext<any>();
  const activeFilterIds = filterIds
    .map((filterId: string) =>
      getFilterConf(filterId).getIsActive(values[filterId]),
    )
    .filter(Boolean);

  const activeFilterCount: number = activeFilterIds.length;

  return (
    <DialogActions>
      <SecondaryButton onClick={onClose} type="button">
        Cancel
      </SecondaryButton>
      <Button type="submit" disabled={readOnly || !isValid}>
        Apply ({activeFilterCount}) {pluralize("Filter", activeFilterCount)}
      </Button>
    </DialogActions>
  );
}
